"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "mb-2 grid grid-cols-2" };
const _hoisted_3 = { class: "mt-1 flex space-x-4" };
const _hoisted_4 = { class: "block font-bold" };
const _hoisted_5 = ["value"];
const _hoisted_6 = {
    key: 0,
    class: "text-shadow-black text-white absolute text-center font-bold w-full"
};
const _hoisted_7 = ["src", "alt", "title"];
const _hoisted_8 = {
    key: 0,
    class: "mt-1"
};
const _hoisted_9 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_10 = { key: 1 };
const _hoisted_11 = {
    for: "search",
    class: "px-4 py-2 inline-block h-full leading-none bg-gray-darker text-white"
};
const _hoisted_12 = {
    class: "inline-block",
    value: "key"
};
const _hoisted_13 = {
    class: "inline-block",
    value: "context"
};
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "pager mt-2 flex justify-center space-x-4" };
const _hoisted_16 = { class: "current font-bold border px-2 py-1 flex items-center" };
const _hoisted_17 = { class: "ml-auto font-bold border px-2 py-1 flex items-center" };
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const TranslationFilterButton_vue_1 = __importDefault(require("./TranslationFilterButton.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const translationStore_1 = require("../../stores/translation/translationStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminTranslations',
    setup(__props) {
        const T = (0, vue_3.inject)("Translator");
        const router = (0, vue_router_1.useRouter)();
        const translationStore = (0, translationStore_1.useTranslationStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const fields = (0, vue_3.computed)(() => {
            var _a, _b, _c;
            let fields = [
                {
                    key: "id",
                    label: (_a = T === null || T === void 0 ? void 0 : T.trans("id", "ID", "translations")) !== null && _a !== void 0 ? _a : "ID",
                    value: "id",
                },
                {
                    key: "context",
                    label: (_b = T === null || T === void 0 ? void 0 : T.trans("context", "Context", "translations")) !== null && _b !== void 0 ? _b : "Context",
                    value: "context",
                },
                {
                    key: "key",
                    label: (_c = T === null || T === void 0 ? void 0 : T.trans("key", "Key", "translations")) !== null && _c !== void 0 ? _c : "Key",
                    value: "key",
                },
                {
                    key: "en",
                    label: "en",
                    value: "en",
                },
                {
                    key: "hu",
                    label: "hu",
                    value: "hu",
                },
                {
                    key: "de",
                    label: "de",
                    value: "de",
                },
                {
                    key: "ro",
                    label: "ro",
                    value: "ro",
                },
                {
                    key: "fr",
                    label: "fr",
                    value: "fr",
                },
                {
                    key: "sr",
                    label: "sr",
                    value: "sr",
                },
                {
                    key: "sk",
                    label: "sk",
                    value: "sk",
                },
                {
                    key: "cs",
                    label: "cs",
                    value: "cs",
                },
                {
                    key: "pl",
                    label: "pl",
                    value: "pl",
                },
            ];
            fields.forEach((column) => {
                if (!["key", "context"].includes(column.key)) {
                    column.visible = translationStore.filters.workingLanguages.includes(column.key);
                }
            });
            return fields;
        });
        const viewPage = (page) => {
            if (1 > page) {
                page = 1;
            }
            translationStore.filters.page = page;
            translationStore
                .loadByFilters(router)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        const validatePage = (event) => {
            if (translationStore.filters.page) {
                let page = Number(translationStore.filters.page.toString().replace(/[^0-9]/g, ""));
                if (translationStore.totalPages < page) {
                    page = translationStore.totalPages;
                }
                translationStore.filters.page = page;
            }
        };
        const validateItemsPerPage = (event) => {
            if (translationStore.filters.itemsPerPage) {
                translationStore.filters.itemsPerPage = Number(translationStore.filters.itemsPerPage
                    .toString()
                    .replace(/[^0-9]/g, ""));
                translationStore.filters.page = 1;
            }
        };
        const updateTranslation = (translation, field, event) => {
            var _a;
            if (event.target instanceof HTMLInputElement) {
                let element = event.target;
                if (element.value === "") {
                    toastStore.addFadingErrorToast((_a = T === null || T === void 0 ? void 0 : T.trans("translation_cant_be_empty", "Translation cant be empty", "translations")) !== null && _a !== void 0 ? _a : "Translation cant be empty!");
                    return;
                }
                element.style.boxShadow = "inset 0px 0px 5px orange";
                element.disabled = true;
                let item = { id: translation.id };
                item[field] = element.value;
                translationStore
                    .updateTranslation(router, item)
                    .then(() => {
                    var _a;
                    element.style.boxShadow = "inset 0px 0px 5px green";
                    setTimeout(() => {
                        element.style.boxShadow = "none";
                        element.disabled = false;
                    }, 3000);
                    toastStore.addToast({
                        title: (_a = T === null || T === void 0 ? void 0 : T.trans("text_saved", `Text saved: "{key}"`, "translations", {
                            key: element.value,
                        })) !== null && _a !== void 0 ? _a : `Text saved:  "${element.value}"`,
                        type: "success",
                        showIcon: false,
                        showClose: false,
                        timer: 3,
                    });
                })
                    .catch((error) => {
                    element.style.boxShadow = "inset 0px 0px 5px red";
                    element.disabled = false;
                    toastStore.addFadingErrorToast(`Text not saved: ${error.toString()}`);
                });
            }
        };
        const order = (field) => {
            if (field === translationStore.filters.orderBy) {
                // actually this field ordered, so toggle the direction
                if ("asc" === translationStore.filters.orderDirection) {
                    translationStore.filters.orderDirection = "desc";
                }
                else {
                    translationStore.filters.orderDirection = "asc";
                }
            }
            else {
                translationStore.filters.orderBy = field;
                translationStore.filters.orderDirection = "asc";
            }
            translationStore
                .loadByFilters(router)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        const workingLanguageSelected = () => {
            if (translationStore.filters.workingLanguages.length) {
                translationStore
                    .loadByFilters(router)
                    .catch((error) => toastStore.addFadingErrorToast(error.toString()));
            }
        };
        const search = () => {
            translationStore
                .loadByFilters(router)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        const writeOutTranslations = (event) => {
            if (event.target instanceof HTMLButtonElement) {
                let button = event.target;
                button.disabled = true;
                translationStore
                    .writeOutTranslations(router)
                    .then((response) => {
                    var _a;
                    toastStore.addToast({
                        title: (_a = T === null || T === void 0 ? void 0 : T.trans("export_complete", "Export complete!", "translations")) !== null && _a !== void 0 ? _a : "Export complete!",
                        type: "success",
                        icon: "marso-icon-right",
                        showClose: false,
                        timer: 5,
                    });
                    button.disabled = false;
                })
                    .catch((error) => {
                    toastStore.addFadingErrorToast(`Export failed: ${error.toString()}`);
                    button.disabled = false;
                });
            }
        };
        const reloadPage = () => {
            translationStore
                .loadByFilters(router)
                .catch((error) => toastStore.addFadingErrorToast(error.toString()));
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.$trans("select_languages", "Select languages", "translations")) + ":", 1),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(translationStore).languages, (lang) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                key: lang.locale,
                                class: "block relative w-6 cursor-pointer"
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (((0, vue_2.unref)(translationStore).filters.workingLanguages) = $event)),
                                    type: "checkbox",
                                    name: "workingLanguages[]",
                                    value: lang.locale,
                                    class: "hidden",
                                    onChange: workingLanguageSelected
                                }, null, 40, _hoisted_5), [
                                    [vue_2.vModelCheckbox, (0, vue_2.unref)(translationStore).filters.workingLanguages]
                                ]),
                                ((0, vue_2.unref)(translationStore).filters.workingLanguages.includes(lang.locale))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, (0, vue_2.toDisplayString)(lang.locale), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("img", {
                                    src: 'images/flags/' + lang.flag,
                                    alt: 'flag ' + lang.title,
                                    title: lang.title
                                }, null, 8, _hoisted_7)
                            ]));
                        }), 128))
                    ]),
                    ((0, vue_2.unref)(translationStore).filters.workingLanguages.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "mx-auto btn btn-primary btn-danger",
                                type: "button",
                                onClick: _cache[1] || (_cache[1] = ($event) => (writeOutTranslations($event)))
                            }, (0, vue_2.toDisplayString)(_ctx.$trans("write_out_current_translations", "Write out current translations", "translations")), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (!(0, vue_2.unref)(translationStore).filters.workingLanguages.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)(_ctx.$trans("flag_helper_text", "Please select first, which languages you want to translate or watch.", "translations")), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(translationStore).filters.workingLanguages.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            items: (0, vue_2.unref)(translationStore).translations,
                            fields: fields.value,
                            condensed: ""
                        }, {
                            header: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("label", _hoisted_11, (0, vue_2.toDisplayString)(_ctx.$trans("search", "Search", "translations")), 1),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (((0, vue_2.unref)(translationStore).filters.searchParameter) = $event)),
                                    class: "inline-block h-full bg-light-gray text-black p-1 leading-none",
                                    onChange: search
                                }, [
                                    (0, vue_2.createElementVNode)("option", _hoisted_12, (0, vue_2.toDisplayString)(_ctx.$trans("key", "Key", "translations")), 1),
                                    (0, vue_2.createElementVNode)("option", _hoisted_13, (0, vue_2.toDisplayString)(_ctx.$trans("context", "Context", "translations")), 1),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(translationStore).filters
                                        .workingLanguages, (lang) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: lang,
                                            class: "inline-block",
                                            value: lang
                                        }, (0, vue_2.toDisplayString)(_ctx.$trans(lang, lang, "translations")), 9, _hoisted_14));
                                    }), 128))
                                ], 544), [
                                    [vue_2.vModelSelect, (0, vue_2.unref)(translationStore).filters.searchParameter]
                                ]),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    id: "search",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (((0, vue_2.unref)(translationStore).filters.searchString) = $event)),
                                    type: "text",
                                    class: "inline-block h-full p-1 text-black leading-none",
                                    onChange: search
                                }, null, 544), [
                                    [vue_2.vModelText, (0, vue_2.unref)(translationStore).filters.searchString]
                                ])
                            ]),
                            "head-context": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('context', 'Context', 'translations'),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (order('context')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-key": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('key', 'Key', 'translations'),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (order('key')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-hu": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('hu', 'HU', 'translations'),
                                    onClick: _cache[6] || (_cache[6] = ($event) => (order('hu')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-en": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('en', 'EN', 'translations'),
                                    onClick: _cache[7] || (_cache[7] = ($event) => (order('en')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-de": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('de', 'DE', 'translations'),
                                    onClick: _cache[8] || (_cache[8] = ($event) => (order('de')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-ro": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('ro', 'RO', 'translations'),
                                    onClick: _cache[9] || (_cache[9] = ($event) => (order('ro')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-fr": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('fr', 'FR', 'translations'),
                                    onClick: _cache[10] || (_cache[10] = ($event) => (order('fr')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-sk": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('sk', 'SK', 'translations'),
                                    onClick: _cache[11] || (_cache[11] = ($event) => (order('sk')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-sr": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('sr', 'SR', 'translations'),
                                    onClick: _cache[12] || (_cache[12] = ($event) => (order('sr')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-cs": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('cs', 'CS', 'translations'),
                                    onClick: _cache[13] || (_cache[13] = ($event) => (order('cs')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-pl": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: (0, vue_2.unref)(translationStore).filters,
                                    label: _ctx.$trans('pl', 'PL', 'translations'),
                                    onClick: _cache[14] || (_cache[14] = ($event) => (order('pl')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "cell-hu": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.hu,
                                    "onUpdate:modelValue": ($event) => ((item.hu) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'hu', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-en": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.en,
                                    "onUpdate:modelValue": ($event) => ((item.en) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'en', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-de": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.de,
                                    "onUpdate:modelValue": ($event) => ((item.de) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'de', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-ro": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.ro,
                                    "onUpdate:modelValue": ($event) => ((item.ro) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'ro', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-fr": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.fr,
                                    "onUpdate:modelValue": ($event) => ((item.fr) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'fr', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-sk": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.sk,
                                    "onUpdate:modelValue": ($event) => ((item.sk) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'sk', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-sr": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.sr,
                                    "onUpdate:modelValue": ($event) => ((item.sr) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'sr', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-cs": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.cs,
                                    "onUpdate:modelValue": ($event) => ((item.cs) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'cs', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-pl": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.pl,
                                    "onUpdate:modelValue": ($event) => ((item.pl) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'pl', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            footer: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-primary",
                                        type: "button",
                                        onClick: _cache[15] || (_cache[15] = ($event) => (viewPage((0, vue_2.unref)(translationStore).filters.page - 1)))
                                    }, (0, vue_2.toDisplayString)(_ctx.$trans("previous", "Previous", "translations")), 1),
                                    (0, vue_2.createElementVNode)("label", _hoisted_16, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("page", "Page", "translations")) + ": ", 1),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => (((0, vue_2.unref)(translationStore).filters.page) = $event)),
                                            class: "w-10 text-center",
                                            type: "text",
                                            onKeyup: [
                                                _cache[17] || (_cache[17] = ($event) => (validatePage($event))),
                                                _cache[18] || (_cache[18] = (0, vue_2.withKeys)(($event) => (reloadPage()), ["enter"]))
                                            ],
                                            onBlur: _cache[19] || (_cache[19] = ($event) => (reloadPage()))
                                        }, null, 544), [
                                            [vue_2.vModelText, (0, vue_2.unref)(translationStore).filters.page]
                                        ]),
                                        (0, vue_2.createTextVNode)(" / " + (0, vue_2.toDisplayString)((0, vue_2.unref)(translationStore).totalPages), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-primary",
                                        type: "button",
                                        onClick: _cache[20] || (_cache[20] = ($event) => (viewPage((0, vue_2.unref)(translationStore).filters.page + 1)))
                                    }, (0, vue_2.toDisplayString)(_ctx.$trans("next", "Next", "translations")), 1),
                                    (0, vue_2.createElementVNode)("label", _hoisted_17, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("items_per_page", "Items per page", "translations")) + ": ", 1),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => (((0, vue_2.unref)(translationStore).filters.itemsPerPage) = $event)),
                                            class: "text-center w-10",
                                            type: "text",
                                            onKeyup: [
                                                _cache[22] || (_cache[22] = ($event) => (validateItemsPerPage($event))),
                                                _cache[23] || (_cache[23] = (0, vue_2.withKeys)(($event) => (reloadPage()), ["enter"]))
                                            ],
                                            onBlur: _cache[24] || (_cache[24] = ($event) => (reloadPage()))
                                        }, null, 544), [
                                            [vue_2.vModelText, (0, vue_2.unref)(translationStore).filters.itemsPerPage]
                                        ]),
                                        (0, vue_2.createTextVNode)(" / " + (0, vue_2.toDisplayString)((0, vue_2.unref)(translationStore).totalItems), 1)
                                    ])
                                ])
                            ]),
                            _: 1
                        }, 8, ["items", "fields"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
